import { passengerTitleEnum } from '../generated';

import type { priceTypeEnum } from '../generated';
import type { ProductWithServices } from '../types';

/**
 * Returns a given product's total price.
 */
export const getTotalPrice = (
  product: ProductWithServices | undefined,
): number | undefined => {
  return product?.priceInformation?.amount;
};

/**
 * Returns the first price corresponding to an adult from given product.
 */
export const getFirstAdultPrice = (
  product: ProductWithServices,
): number | undefined => {
  return getFirstPassengerPrice(product, passengerTitleEnum.H);
};

// /**
//  * Returns the first price corresponding to a child from given product.
//  */
// export const getFirstChildPrice = (product: ProductWithServices): number | undefined => {
//   return getFirstPassengerPrice(product, passengerTitleEnum.K);
// }

const getFirstPassengerPrice = (
  product: ProductWithServices,
  type: passengerTitleEnum,
) => {
  const first = product.priceInformation?.passengerPrices?.find(
    ({ title }) => title === type,
  );

  if (typeof first === 'undefined') {
    return undefined;
  }

  return first.amount;
};

/**
 * Returns the first price detail of given type from given product.
 * If type is an array, returns the first price detail of any of that type from given product.
 */
export const getPriceDetails = (
  product: ProductWithServices,
  type: priceTypeEnum | priceTypeEnum[],
) => {
  const types = Array.isArray(type) ? type : [type];

  return product.priceInformation?.priceDetails?.find(
    ({ priceType }) => priceType && types.indexOf(priceType) > -1,
  );
};
